import { MutationTree } from "vuex";
import { ACTIVITES_STORE as S, ActivitesState } from "./types";

export const mutations: MutationTree<ActivitesState> = {
    [S.SET_ACTIVITES](state, activites) {
        state.activites = activites;
    },
    [S.SET_CURRENT_ACTIVITE](state, currentActivite) {
        state.currentActivite = currentActivite;
    },
    [S.SET_TYPES_ACTIVITES](state, typesActivites) {
        state.typesActivites = typesActivites;
    },
    [S.SET_FILTRED_ACTIVITES](state, filtredActivites) {
        state.filtredActivites = filtredActivites;
    },
    [S.SET_CURRENT_DATE](state, currentDate) {
        state.currentDate = currentDate;
    },
    [S.SET_IS_DATE_DIFF](state, newVal : boolean){
        state.isDateDiff = newVal;
    }
};
